import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form } from 'react-bootstrap'
import MyEditor from '../../components/MyEditor'
import { useNavigate, useParams } from 'react-router-dom'
import axiosInstance from '../../utils/axiosConfig'
import * as CustomToast from '../../components/CustomToastMessage';

function SettingsAdd() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        title: '',
        content: '',
    });
    const [loading, setLoading] = useState(false);

    const fetchSettingDetails = useCallback(async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/settings/${id}`);
            if (response.data.success) {
                const tip = response.data.data;
                setFormData({
                    title: tip.title,
                    content: tip.content,
                });
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        }
    }, [id])
    useEffect(() => {
        if (id) {
            fetchSettingDetails();
        }
    }, [id, fetchSettingDetails]);
    const handleSubmit = async () => {

        try {
            setLoading(true);
            const url = id
                ? `${process.env.REACT_APP_BACKEND_URL}/api/admin/settings/edit/${id}`
                : `${process.env.REACT_APP_BACKEND_URL}/api/admin/settings/create`;

            const method = id ? 'put' : 'post';

            const response = await axiosInstance({
                method,
                url,
                data: formData
            });

            if (response.data.success) {
                CustomToast.success(response.data.message);
                navigate('/settings');
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };

    const handleEditorChange = (content) => {
        setFormData(prev => ({
            ...prev,
            content: content
        }));
    };
    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };
    return (
        <Layout title={id ? "Edit Setting" : "New Setting"}>
            <main>
                <div className="card page-card">
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-12">
                                <Form.Group controlId="ItemKey">
                                    <Form.Label>Item Key</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        placeholder="Enter title"
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-12">
                                <Form.Group controlId="Password">
                                    <Form.Label>Item Value</Form.Label>
                                </Form.Group>
                                <MyEditor
                                    htmlData={formData.content}
                                    setCourseAdd={(content) => {
                                        handleEditorChange(content);
                                    }}
                                />
                            </div>
                            <div className="col-12 d-flex justify-content-end gap-3">
                                <button className='btn-outline fs-16 fw-700 px-4' onClick={() => navigate('/settings')}>
                                    Cancel
                                </button>
                                <button className='btn-primary fs-16 fw-700 px-4' onClick={handleSubmit} disabled={loading}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout >
    )
}

export default SettingsAdd